/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tool_FeaturedInputs */

const en_directory_tool_featured = /** @type {(inputs: Directory_Tool_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured`)
};

const zh_directory_tool_featured = /** @type {(inputs: Directory_Tool_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精选`)
};

/**
* | output |
* | --- |
* | "Featured" |
*
* @param {Directory_Tool_FeaturedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tool_featured = /** @type {((inputs?: Directory_Tool_FeaturedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tool_FeaturedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tool_featured(inputs)
	return zh_directory_tool_featured(inputs)
});
export { directory_tool_featured as "directory.tool.featured" }